import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSatellite1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSatellite1"><Path d="M2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C14.4962 21.5 16.7675 20.5373 18.4629 18.9629L5.03711 5.53711C3.46272 7.23252 2.5 9.50383 2.5 12Z" stroke="currentColor"/><Path d="M12 12L13.5 10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 12C21.5 6.75329 17.2467 2.5 12 2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 12C18.5 8.41015 15.5899 5.5 12 5.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSatellite1;
